<template>
  <header
    class="relative overflow-hidden py-9 md:py-12"
    data-testid="futures-header"
    description=""
    title=""
  >
    <!-- Image -->
    <img
      class="absolute inset-0 size-[200%] object-cover object-[-12rem_-4.5rem] md:h-[calc(100%_+_4rem)] md:w-full md:object-[0_-4rem]"
      src="https://res.cloudinary.com/benchmarkminerals/image/upload/q_auto,f_auto/v1744123688/assets/ice/ice-common/0c96fdb328674e27fa1bbf5d805ca430_ueugeo.png"
      aria-hidden="false"
      alt=""
    />

    <!-- Overlay -->
    <div
      class="min-w-header-content absolute inset-0 h-full overflow-hidden bg-black/60 md:w-1/2 md:rounded-r-xl md:bg-black/50 md:backdrop-blur-[2px]"
    />

    <!-- Content -->
    <div class="relative mx-4.5 md:py-20">
      <div class="mx-auto max-w-content-container">
        <div class="min-w-header-content text-white md:w-1/2 md:pr-12">
          <h1 class="mb-5 text-h3 md:mb-6 md:text-h2">
            {{ title }}
          </h1>
          <p class="mb-20 text-h5 md:mb-7">
            {{ description }}
          </p>
          <ButtonContactUs class="w-full md:w-fit" text="Contact Us" />
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import ButtonContactUs from '~/components/shared/common/ButtonContactUs.vue'

defineProps<{
  title: string
  description: string
}>()
</script>

<style scoped>
.min-w-header-content {
  @apply md:min-w-[38.75rem];
}
</style>
